'use client';

import { FC, useEffect } from 'react';
import { GiftFinderWizardStoryblok } from 'storyblok-types';
import { MainCategoryItem } from '../../GiftFinder/MainCategoryItem';
import { WizardSteps } from '../WizardSteps';
import { useGiftFinderStore } from '../store';
import styles from './styles.module.css';

export const GiftFinderWizard: FC<{ blok: GiftFinderWizardStoryblok }> = ({
  blok,
}) => {
  const { parentCategories } = blok;
  const { currentStep, activeItemIndex, setActiveItemIndex, setCurrentStep } =
    useGiftFinderStore();

  useEffect(() => {
    if (currentStep === 1) {
      setActiveItemIndex(null);
    }
  }, [currentStep, setActiveItemIndex]);

  const renderParentCategories = () =>
    parentCategories.map((category, index) => (
      <MainCategoryItem
        key={category._uid}
        isActive={activeItemIndex === index && currentStep > 1}
        backgroundColor={category.backgroundColor?.color}
        image={category.image?.filename}
        blockColor={category.color || ''}
        title={category.title}
        index={index}
        subCategories={category.subCategories}
        filterValue={category.filterValue}
        blockData={blok}
      />
    ));

  return (
    <div className={styles.container}>
      <div className={styles.mainWrapper}>
        <div className={styles.inquiryWrapper}>{renderParentCategories()}</div>
      </div>
      <WizardSteps activeStep={currentStep} setActive={setCurrentStep} />
    </div>
  );
};
